import { Content } from '../../Modal'
import {
  useEmailReplyFormInitEditor,
  useEmailReplyFormShowConversation,
} from '../Email.hooks'
import { EmailCreationPopupContainer } from '../EmailCreationPopupContainer'
import { EmailReplyForm } from '../EmailReplyForm'

import * as styles from './EmailModalReplyForm.module.css'

function EmailModalReplyForm({
  contentComponentProps,
  formFieldsProps,
  formProps,
  initialValues,
  ...restProps
}) {
  const { editorRef, handleInitEditor } = useEmailReplyFormInitEditor()

  const { toggleExpandConversation } = useEmailReplyFormShowConversation({
    editorRef,
  })

  return (
    <EmailReplyForm
      {...restProps}
      FormContainer={EmailCreationPopupContainer}
      contentComponentProps={{
        ...contentComponentProps,
        shadow: true,
      }}
      formFieldsProps={{ ...formFieldsProps, ContentComponent: Content }}
      formProps={{ ...formProps, className: styles.formBody }}
      initialValues={initialValues}
      onInitEditor={handleInitEditor}
      onToggleExpandConversation={toggleExpandConversation}
    />
  )
}

export default EmailModalReplyForm
